__turbopack_context__.v({
  "soldLabel": "gNN0oW_soldLabel",
  "soldLabelLegacyButton": "gNN0oW_soldLabelLegacyButton",
  "soldLabelThrift": "gNN0oW_soldLabelThrift",
});
